import React from 'react'
import ReactDom from 'react-dom'
import moment from 'moment'
import { trackEvent } from '../utilities/analytics'

class UnitDetails extends React.Component {

  constructor(props) {
    super(props)

    this.handleClose = this.handleClose.bind(this)
    this.handleCallToAction = this.handleCallToAction.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.floorPlanImageField !== this.props.floorPlanImageField
    || nextProps.unit !== this.props.unit
  }

  handleClose(event) {
    if (this.props.onClose) {
      event.preventDefault()
      this.props.onClose({
        unit: this.props.unit
      })
    }
  }

  handleCallToAction(event) {
    trackEvent({
      category: 'Unit Detail Modal',
      action: 'Call To Action',
      label: `${event.target.text}`
    })
  }

  render() {
    const {
      config,
      floorPlanImageField,
      unit
    } = this.props

    let applyUrl = config.urls.apply
    if (applyUrl) {
      for (var attribute in unit) {
        let pattern = new RegExp('{' + attribute + '}', 'g')
        applyUrl = applyUrl.replace(pattern, unit[attribute])
      }
    }

    return (
      <div id="details-container" onClick={this.handleClose}>
      	<div className="details" onClick={(event) => event.stopPropagation()}>
      		<a className="close-details" href="#" onClick={this.handleClose}>
            Go<span>Back</span>
          </a>
      		<div className="main-details-container">
      			<div className="left-column">
      				<img src={unit[`floorplan_${floorPlanImageField}`]} alt="" />
      			</div>
      			<div className="right-column">
              <div className="right-column-content">
        				<h1>Apt {unit.unitnumber}</h1>
        				<h2>{unit.floorplan_name}</h2>

        				<hr/>

        				<p>
        					<span>{unit.floorplan_bedroomcount === '0' ? 'Studio' : unit.floorplan_bedroomcount + ' bed'} / {parseFloat(unit.floorplan_bathroomcount).toString()} bath</span><br/>
        					<span>{unit.area} Sq. Ft.</span><br/>
        					<span>${parseInt(unit.price)}</span><br/>
        					<span style={{fontWeight: '600', textTransform: 'uppercase'}}>Available {unit.available === '2' ? 'Now' : moment(unit.available_date, 'YYYY-MM-DD').format('MMM Do') }</span>
        				</p>

        				<div className="details-link-list">
        					<ul>
                    {applyUrl ?
                      <li>
          							<a className="reserve" href={applyUrl} onClick={this.handleCallToAction} target="_blank">Apply</a>
          						</li>
                    : null }

                    {config.urls.contact ?
          						<li>
          							<a className="email" href={config.urls.contact} onClick={this.handleCallToAction} target="_blank">Contact</a>
          						</li>
                    : null }
                  </ul>
        				</div>
              </div>
      			</div>
      		</div>
      	</div>
      </div>
    )
  }
}

export default UnitDetails
